import Vue from 'vue';
import { gsap } from 'gsap';

Vue.component('video-component', {

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            video: null,
            videoPlaying: false,
            showPoster: true,
            curtain: null,
            isAnimating: false
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        // Vue.nextTick(() => {
        //     Vue.nextTick(this.setupVideo);
        // });
        this.curtain = this.$el.querySelector('.video__curtain');
        this.videoPoster = this.$el.querySelector('.video__poster-holder img');
        this.intersect();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        intersect() {
            var options = {
                rootMargin: "300px",
                threshold: 0
            };

            var video = this.$refs.video;

            var observer = new IntersectionObserver((entries, observer) => {
                var isIntersecting =
                    typeof entries[0].isIntersecting === "boolean"
                        ? entries[0].isIntersecting
                        : entries[0].intersectionRatio > 0;
                if (isIntersecting) {
                    this.setupVideo();
                    observer.unobserve(video);
                }
            }, options);

            observer.observe(video);
        },

        toggleVideo() {
            if (this.videoPlaying) {
                this.animateCurtain(false);
                return;
            }

            this.animateCurtain(true);
        },

        // playVideo() {
        //     this.video.play();
        //     this.videoPlaying = true;
        // },

        async setupVideo() {
            const Plyr = await import(/* webpackChunkName: "plyr" */ 'plyr')
                .then(module => {
                    return module.default
                }) // using the default export
                .catch(() => {
                    console.log('Handle error!');
                });

            this.video = new Plyr(this.$refs.video, {
                settings: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'],
            });

            if (!this.video) {
                return;
            }

            this.video.on('play', (event) => {
            });

            this.video.on('pause', (event) => {
            });

            this.video.on('seeking', (event) => {
                this.videoPlaying = true;
            });

            this.video.on('ended', (event) => {
                this.animateCurtain(false);
            });
        },

        animateCurtain(videoPlaying) {
            if (this.isAnimating) {
                return;
            }

            this.isAnimating = true;

            // Hack to make the video play even if this is triggered in an animation and/or via a timeout/timeout-like-event
            // https://stackoverflow.com/questions/10983731/html5-audio-object-doesnt-play-on-ipad-when-called-from-a-settimeout
            if (videoPlaying) {
                this.video.play();
                this.video.pause();
            }

            const tl = gsap.timeline();
            tl
                .to(this.curtain, {
                    duration: 1,
                    scaleY: 1,
                    ease: 'power4.out',
                    onComplete: () => {
                        this.showPoster = !this.showPoster;
                    }
                })
                .set(this.videoPoster, {
                    scale: !videoPlaying ? 1.1 : 1
                })
                .set(this.curtain, {
                    transformOrigin: 'top center'
                })
                .to(this.curtain, {
                    onStart: () => {
                        this.videoPlaying = videoPlaying;
                        if (videoPlaying) {
                            this.video.play();
                            return;
                        }

                        this.video.pause();
                    },
                    duration: 1,
                    scaleY: 0,
                    ease: 'power4.out',
                    onComplete: () => {
                        this.isAnimating = false;
                    }
                })
                .to(this.videoPoster, {
                    duration: 0.8,
                    scale: !videoPlaying ? 1 : 1.1,
                    ease: 'power4.out'
                }, '<+0.1')
                .set(this.curtain, {
                    transformOrigin: 'bottom center'
                });
        }
    },
});
